import {
  remove as removeLocalStorageItem,
} from 'lib/storage/isomorphicLocalStorage'
import { remove as removeSessionStorageItem } from 'lib/storage/isomorphicSessionStorage'
import {
  isExpiringDismissalActive,
  setExpiringDismissal,
} from './expiringDismissalEntry'

const LAB_MODAL_POPUP_KEY_PREFIX = 'labModalPopup:'
const LAB_MODAL_SESSION_GATE_KEY = 'labModalPopup:sessionGate'
const LEGACY_LAB_MODAL_POPUP_DISMISSALS_KEY = 'labModalPopupDismissals'
const LEGACY_LAB_MODAL_POPUPS_SEEN_SESSION_KEY = 'labModalPopupsSeenThisSession'
const LEGACY_LAB_MODAL_SESSION_GATE_SESSION_KEY = 'labModalPopupPresentedThisSession'
const PERMANENT_DISMISSAL_END_DATE = '9999-12-31T23:59:59.999Z'
const ONCE_PER_7_DAYS_TTL_DAYS = 7

let didRemoveLegacyKeys = false

// TODO(2026-09-17): Remove legacy key cleanup after ~1 month — old map/session keys should be gone from clients.
function removeLegacyKeys() {
  if (didRemoveLegacyKeys) return
  didRemoveLegacyKeys = true

  try {
    removeLocalStorageItem(LEGACY_LAB_MODAL_POPUP_DISMISSALS_KEY)
  } catch {
    // Storage can fail in privacy modes or when quota is exhausted.
  }

  try {
    removeSessionStorageItem(LEGACY_LAB_MODAL_POPUPS_SEEN_SESSION_KEY)
    removeSessionStorageItem(LEGACY_LAB_MODAL_SESSION_GATE_SESSION_KEY)
  } catch {
    // Storage can fail in privacy modes or when quota is exhausted.
  }
}

function storageKey(id: string) {
  return `${LAB_MODAL_POPUP_KEY_PREFIX}${id}`
}

/** Local calendar midnight `days` from today (1 = next local midnight). */
function getLocalMidnightAfterDays(days: number): string {
  const date = new Date()
  date.setDate(date.getDate() + days)
  date.setHours(0, 0, 0, 0)
  return date.toISOString()
}

function getDismissalEndDate(displayFrequency: App.LabModalPopupResult['displayFrequency']): string {
  switch (displayFrequency) {
    case 'once':
      return PERMANENT_DISMISSAL_END_DATE
    case 'oncePerSession':
      return getLocalMidnightAfterDays(1)
    case 'oncePer7Days':
      return getLocalMidnightAfterDays(ONCE_PER_7_DAYS_TTL_DAYS)
  }
}

/**
 * At most one Lab modal across the site until next local midnight.
 * Uses localStorage so it survives refresh, in-tab navigation, and new tabs.
 */
export function hasPresentedLabModalThisSession(): boolean {
  removeLegacyKeys()
  return isExpiringDismissalActive(LAB_MODAL_SESSION_GATE_KEY)
}

export function isModalPopupSuppressed(popup: App.LabModalPopupResult): boolean {
  removeLegacyKeys()
  return isExpiringDismissalActive(storageKey(popup.id))
}

export function recordModalPopupSeen(popup: App.LabModalPopupResult) {
  removeLegacyKeys()
  setExpiringDismissal(LAB_MODAL_SESSION_GATE_KEY, getLocalMidnightAfterDays(1))
  setExpiringDismissal(storageKey(popup.id), getDismissalEndDate(popup.displayFrequency))
}
